import React, { FunctionComponent, useState, useEffect } from 'react'
import { ProgressBar } from '@afterpaytouch/core'
import { PERSONALIZATION_REDIRECTION_DELAY_MS } from '../../../model'
import clsx from 'clsx'

import styles from './styles.module.css'

interface Props {
  show?: boolean
  visible?: boolean
}

export const Progress: FunctionComponent<Props> = ({ show = false, visible = false }) => {
  const progressBarStyle = clsx(styles.progressBarWrapper, visible && styles.showProgressBar)
  const [percent, setPercent] = useState(0)

  useEffect(() => {
    let count = 0
    const delayInSecond = PERSONALIZATION_REDIRECTION_DELAY_MS / 1000
    const countStep = Math.round(100 / (delayInSecond - 2))
    const progressBarAnimation = setInterval(() => {
      if (count >= 100) {
        setPercent(100)
        clearInterval(progressBarAnimation)
      } else {
        setPercent(count)
        count += countStep
      }
    }, 1000)
    return () => clearInterval(progressBarAnimation)
  }, [])

  if (!show) {
    return null
  }

  return (
    <div className={progressBarStyle}>
      <ProgressBar percent={percent} />
    </div>
  )
}
